import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-1">
      <div
        class="w-[10px] h-[10px] rounded-full"
        [style.background]="color"
      ></div>
      {{ label }}
    </div>
  `,
})
export class StatusBadgeComponent {
  @Input() status: string | undefined;

  get label(): string {
    switch (this.status?.toUpperCase()) {
      case 'PAID':
        return 'Paid';
      case 'NOT_PAID':
      default:
        return 'Not Paid';
    }
  }

  get color(): string {
    switch (this.status?.toUpperCase()) {
      case 'PAID':
        return '#4AC99B';
      case 'NOT_PAID':
      default:
        return '#FF4646';
    }
  }
}
